<dx-load-panel
  [hideOnOutsideClick]="false"
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingIndicator">
</dx-load-panel>
<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="normalStockForm" #f="ngForm" novalidate>
        <app-panel [footer]="true">
          <div class="heading" #customerInformation>Customer Information</div>
          <div class="toolbar" *ngIf="salesOrderId">Order #. {{salesOrderId}}</div>
          <div class="body">
            <div class="row">
              <div class="col-2">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label [for]="customerTypeId" text="Customer Type *"></kendo-label>
                    <kendo-combobox [virtual]="true"
                    [clearButton]="true" 
                    #customerTypeId
                    [tabIndex]="1"
                    [readonly]="!customerTypelist?.length"
                    class="w-100" 
                    formControlName="customerTypeId"
                    [valuePrimitive]="true"
                    [data]="customerTypelist"
                    [valueField]="'customerTypeId'"
                    [textField]="'customerTypeName'" 
                    required
                    [filterable]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                    [suggest]="true" 
                    [loading]="loadingCustomerType"
                    
                    [placeholder]="loadingCustomerType ? 'Please wait...' : 'Customer Type'"
                    >
                    </kendo-combobox>
                    <kendo-formerror>Customer Type is required</kendo-formerror>
                  </kendo-formfield>
                  <!-- (valueChange)="filterCustomer(normalStockForm.get('customerTypeId').value)" -->
                  <!-- <div>Customer Type <span>*</span>:</div>
                  <dx-select-box  [tabIndex]="1"
                    [inputAttr]="{ autocomplete: 'off' }"
                    formControlName="customerTypeId"
                    [items]="customerTypelist"
                    placeholder="{{
                      loadingCustomerType
                        ? 'Please wait...'
                        : 'Select Customer Type *'
                    }}"
                    (onOpened)="onOpend()"
                    
                    displayExpr="customerTypeName"
                    valueExpr="customerTypeId"
                    [deferRendering]="false"
                    [searchEnabled]="true"
                    (onValueChanged)="
                      filterCustomer(
                        normalStockForm.get('customerTypeId').value
                      )
                    "
                  >
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="Customer Type is required"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box> -->
                </div>
              </div>
              <div class="col-4">
                <div class="dx-field hightLight">
                  <kendo-formfield>
                    <kendo-label [for]="customerBranchId" text="Customer Name *"></kendo-label>
                    <kendo-combobox [virtual]="true"
                    [clearButton]="true" 
                    #customerBranchId
                    [tabIndex]="2"
                    [readonly]="!customerList?.length && !normalStockForm.get('customerTypeId').value"
                    class="w-100" 
                    formControlName="customerBranchId"
                    [valuePrimitive]="true"
                    [data]="customerList"
                    [valueField]="'customerBranchId'"
                    [textField]="'customerName'" 
                    required
                    [filterable]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                    [suggest]="true"
                    [loading]="loadingCustomer" 
                    (valueChange)="changeCustomerEvent($event)"
                    
                    [placeholder]="loadingCustomer ? 'Please wait...' : 'Customer Name'"
                    >
                    </kendo-combobox>
                    <kendo-formerror>Customer Name is required</kendo-formerror>
                  </kendo-formfield>
                  <!-- (valueChange)="getCustomerContactName(normalStockForm.get('customerBranchId').value);getViewImtemCatalog();" -->
                  <!-- <div>Customer Name <span>*</span>:</div>
                  <dx-select-box  [tabIndex]="2"
                    [inputAttr]="{ autocomplete: 'off' }"
                    formControlName="customerBranchId"
                    [items]="customerList"
                    placeholder="{{
                      loadingCustomer
                        ? 'Please wait...'
                        : 'Select Customer Name *'
                    }}"
                    [showDropDownButton]="true"
                    displayExpr="customerName"
                    valueExpr="customerBranchId"
                    [searchEnabled]="true"
                    [deferRendering]="false"
                    [readOnly]="!normalStockForm.get('customerTypeId').value"
                    (onSelectionChanged)="getCustomerContactName($event);getViewImtemCatalog();"
                  >
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="Customer Name is required"
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box> -->
                </div>
              </div>
              <div class="col-2">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label [for]="customerContactId" text="Customer Contact"></kendo-label>
                    <kendo-combobox [virtual]="true"
                    [clearButton]="true" 
                    #customerContactId
                    [tabIndex]="3"
                    [readonly]="normalStockForm.get('customerBranchId').value
                    ? null
                    : true"
                    class="w-100" 
                    formControlName="customerContactId"
                    [valuePrimitive]="true"
                    [data]="customerContactList"
                    [valueField]="'customerContactId'"
                    [textField]="'contactName'" 
                    [filterable]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                    [suggest]="true" 
                    placeholder="Select Customer Contact"
                    >
                    </kendo-combobox>
                  </kendo-formfield>
                  <!-- <div>Customer Contact:</div>
                  <dx-select-box [tabIndex]="3"
                    [inputAttr]="{ autocomplete: 'off' }"
                    [readOnly]="
                      normalStockForm.get('customerBranchId').value
                        ? null
                        : true
                    "
                    formControlName="customerContactId"
                    [items]="customerContactList"
                    placeholder="Select Customer Contact"
                    [showClearButton]="true"
                    displayExpr="contactName"
                    [deferRendering]="false"
                    valueExpr="customerContactId"
                    [searchEnabled]="true"
                  >
                  </dx-select-box> -->
                </div>
              </div>
              <div class="col-md-2">
                <div class="dx-field">
                  <kendo-formfield>
                    <kendo-label [for]="urgencyTypeId" text="Urgency Type *"></kendo-label>
                    <kendo-combobox [virtual]="true"
                    [clearButton]="true" 
                    #urgencyTypeId
                    [tabIndex]="4"
                    class="w-100" 
                    formControlName="urgencyTypeId"
                    [valuePrimitive]="true"
                    [data]="urgencyTypeList"
                    [valueField]="'urgencyTypeId'"
                    [textField]="'urgencyTypeName'" 
                    required
                    [filterable]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                    [suggest]="true"
                    placeholder="Urgency Type"
                    >
                    </kendo-combobox>
                    <kendo-formerror>Urgency Type is required</kendo-formerror>
                  </kendo-formfield>
                  <!-- <div>Urgency Type <span>*</span>:</div>
                  <dx-select-box
                    [tabIndex]="4"
                    [inputAttr]="{ autocomplete: 'off' }"
                    [items]="urgencyTypeList"
                    placeholder="Select Urgency Type"
                    [showClearButton]="true"
                    displayExpr="urgencyTypeName"
                    valueExpr="urgencyTypeId"
                    formControlName="urgencyTypeId"
                    [searchEnabled]="true"
                    [deferRendering]="false"
                  >
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="Urgency Type is required"
                      >
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box> -->
                </div>
              </div>
              <div class="col-md-2">
                <div class="dx-field">
                  <div>Patient Name :</div>
                  <dx-text-box
                    [tabIndex]="5"
                    [inputAttr]="{ autocomplete: 'off' }"
                    placeholder="Patient Name"
                    formControlName="patientName"
                  ></dx-text-box>
                </div>
              </div>
              <div class="col-md-2">
                <div class="dx-field">
                  <!--  && !selectedCustomerContactEvent?.doNotDuplicatePO -->
                  <div>PO Ref. NO <span *ngIf="selectedCustomerContactEvent?.providePO">*</span>:</div>
                  <dx-text-box
                    [tabIndex]="6"
                    [inputAttr]="{ autocomplete: 'off' }"
                    placeholder="PO Ref. NO"
                    [disabled]="!normalStockForm.get('customerBranchId').value"
                    formControlName="ponumber"
                    (onFocusOut)="isValidatePONumber(normalStockForm.get('ponumber').value, customerId)"
                  >
                  <dx-validator>
                    <dxi-validation-rule *ngIf="selectedCustomerContactEvent?.providePO"
                      type="required"
                      message="PO Ref. NO is required"
                    >
                    </dxi-validation-rule>
                  </dx-validator>
                </dx-text-box>
                </div>
              </div>
              <div class="col-md-2">
                <div class="dx-field">
                  <div>Partner Order NO :</div>
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    placeholder="Partner Order NO"
                    formControlName="partnerOrderNumber"
                    [tabIndex]="7"
                  ></dx-text-box>
                </div>
              </div>
              <div class="col-2">
                <div class="dx-field">
                  <div>Instruction :</div>
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    placeholder="Instruction"
                    formControlName="instruction"
                    [tabIndex]="8"
                  ></dx-text-box>
                </div>
              </div>
              <div class="col-6">
                <div class="dx-field">
                  <div>Remarks :</div>
                  <dx-text-box
                    [inputAttr]="{ autocomplete: 'off' }"
                    placeholder="Remarks"
                    formControlName="remarks"
                    [tabIndex]="9"
                  ></dx-text-box>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="float-right">
              <dx-button 
                id="submit"
                [text]="'Refresh'"
                type="default"  
                class="float-right ml-3"
                (click)="resetAll()"
                [useSubmitBehavior]="false">
              </dx-button>
            </div>
          </div>
        </app-panel>
        <div class="clearfix"></div>
        <div class="mt-3"></div>
        <ng-container *ngIf="normalStockForm.get('customerTypeId').value && normalStockForm.get('customerBranchId').value">
          <app-panel [footer]="stockLense?.length > 0 ? true : false" [backArrow]="false">
            <div class="heading">Stock Lense</div>
            <div class="body">
              <div class="row" formGroupName="filtersInventory" #form>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="brandMasterId" text="Brands *"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #brandMasterId
                      [readonly]="!brandsList?.length"
                      class="w-100" 
                      formControlName="brandMasterId"
                      [valuePrimitive]="true"
                      [data]="brandsList"
                      [valueField]="'brandMasterId'"
                      [textField]="'brandName'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      required
                      (valueChange)="getViewImtemCatalog()"
                      [placeholder]="loadingBrand ? 'Please wait...' : 'Choose Brand Name'"
                      [tabIndex]="10">
                    </kendo-combobox>
                      <kendo-formerror>Brand is required</kendo-formerror>
                      </kendo-formfield>
                    <!-- <div>Brands<span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="brandsList"
                      placeholder="{{
                        loadingBrand ? 'Please wait...' : 'Choose Brand Name'
                      }}"
                      [showClearButton]="true"
                      displayExpr="brandName"
                      valueExpr="brandMasterId"
                      [readOnly]="!brandsList?.length"
                      [searchEnabled]="true"
                      [deferRendering]="false"
                      formControlName="brandMasterId"
                      (onValueChanged)="getViewImtemCatalog()"
                    >
                      <dx-validator>
                        <dxi-validation-rule
                          type="required"
                          message="Brand Name is required"
                        >
                        </dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="materialId" text="Material"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #materialId
                      [readonly]="!allMaterials?.length"
                      class="w-100" 
                      formControlName="materialId"
                      [valuePrimitive]="true"
                      [data]="allMaterials"
                      [valueField]="'materialId'"
                      [textField]="'materialName'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getStockIndex(normalStockForm.get('filtersInventory').get('materialId').value)"
                      [placeholder]="loadingMaterials ? 'Please wait...' : 'Choose Material'"
                      [tabIndex]="11">
                      </kendo-combobox>
                    </kendo-formfield>
                    <!-- <div>Material :</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="allMaterials"
                      placeholder="{{
                        loadingMaterials ? 'Please wait...' : 'Choose Material'
                      }}"
                      [showClearButton]="true"
                      displayExpr="materialName"
                      valueExpr="materialId"
                      [searchEnabled]="true"
                      [deferRendering]="false"
                      [readOnly]="!allMaterials?.length"
                      formControlName="materialId"
                      (onValueChanged)="
                        getAllIndexByMaterialId(
                          normalStockForm
                            .get('filtersInventory')
                            .get('materialId').value
                        )
                      "
                    >
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="focalId" text="Focal"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #focalId
                      [readonly]="!focalIdsList?.length"
                      class="w-100" 
                      formControlName="focalId"
                      [valuePrimitive]="true"
                      [data]="focalIdsList"
                      [valueField]="'focalId'"
                      [textField]="'focalName'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getViewImtemCatalog()"
                      [placeholder]="loadingFocal ? 'Please wait...' : 'Choose Focal'"
                      [tabIndex]="12">
                      </kendo-combobox>
                    </kendo-formfield>
                    <!-- <div>Focal :</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="focalIdsList"
                      placeholder="{{loadingFocal ? 'Please wait...' : 'Choose Focal ID'}}"
                      [showClearButton]="true"
                      [deferRendering]="false"
                      displayExpr="focalName"
                      valueExpr="focalId"
                      [readOnly]="!focalIdsList?.length"
                      [searchEnabled]="true"
                      formControlName="focalId"
                      (onValueChanged)="getViewImtemCatalog()">
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="indexId" text="Indexs"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #indexId
                      [readonly]="!indexList?.length"
                      class="w-100" 
                      formControlName="indexId"
                      [valuePrimitive]="true"
                      [data]="indexList"
                      [valueField]="'indexId'"
                      [textField]="'indexValue'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getViewImtemCatalog()"
                      [placeholder]="loadingFocal ? 'Please wait...' : 'Choose Indexs'"
                      [tabIndex]="13">
                      </kendo-combobox>
                    </kendo-formfield>
                    <!-- <div>Indexs:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="indexList"
                      placeholder="{{
                        loadingIndex ? 'Please wait...' : 'Choose Indexs'
                      }}"
                      [showClearButton]="true"
                      [deferRendering]="false"
                      displayExpr="indexValue"
                      valueExpr="indexId"
                      [readOnly]="!indexList?.length"
                      [searchEnabled]="true"
                      formControlName="indexId"
                      (onValueChanged)="getViewImtemCatalog()"
                    >
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="filterId" text="Filters"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #filterId
                      [readonly]="!filterList?.length"
                      class="w-100" 
                      formControlName="filterId"
                      [valuePrimitive]="true"
                      [data]="filterList"
                      [valueField]="'filterId'"
                      [textField]="'filterName'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getViewImtemCatalog()"
                      [placeholder]="loadingFilters ? 'Please wait...' : 'Choose Filters'"
                      [tabIndex]="14">
                      </kendo-combobox>
                    </kendo-formfield>
                    <!-- <div>Filters :</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="filterList"
                      placeholder="{{
                        loadingBrand ? 'Please wait...' : 'Choose Filters'
                      }}"
                      [showClearButton]="true"
                      [deferRendering]="false"
                      displayExpr="filterName"
                      valueExpr="filterId"
                      [readOnly]="!filterList?.length"
                      [searchEnabled]="true"
                      formControlName="filterId"
                      (onValueChanged)="getViewImtemCatalog()"
                    >
                   
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <div>Transtose:</div>
                        <dx-switch 
                          [width]="130"   
                          [disabled]="isTranspose"  
                          formControlName="isTranspose" 
                          class="mt-2"
                          (onValueChanged)="ValueCalculateToTranstose
                            ( 
                              normalStockForm.get('filtersInventory').get('sph').value, 
                              normalStockForm.get('filtersInventory').get('cyl').value
                            )"
                            >
                          </dx-switch>
                         <!-- <button (click)="resetTranstose()" *ngIf="isTranspose" mat-icon-button aria-label="Example icon-button with a heart icon">
                          <mat-icon>refresh</mat-icon>
                        </button> -->
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="dx-field hightLight">
                    <kendo-formfield>
                      <kendo-label [for]="itemCatalogGroupId" text="Lens Type *"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #itemCatalogGroupId
                      class="w-100" 
                      [loading]="loadingItemCatalog"
                      formControlName="itemCatalogGroupId"
                      [valuePrimitive]="true"
                      [data]="itemCatalogList"
                      [valueField]="'itemCatalogGroupId'"
                      [textField]="'itemName'" 
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="selectedItemCatalogGroup(
                        normalStockForm
                          .get('filtersInventory')
                          .get('itemCatalogGroupId').value
                      );getGroupSize();
                      "
                      [placeholder]="loadingItemCatalog
                      ? 'Please wait...'
                      : 'Choose Lens Type'"
                      [tabIndex]="15">
                      </kendo-combobox>
                      <kendo-formerror>Lens Type is required</kendo-formerror>
                    </kendo-formfield>
                    <!-- <div>Catalog Group <span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="itemCatalogList"
                      placeholder="{{
                        loadingItemCatalog
                          ? 'Please wait...'
                          : 'Choose Item Catalog'
                      }}"
                      [showClearButton]="true"
                      displayExpr="itemName"
                      valueExpr="itemCatalogGroupId"
                      [searchEnabled]="true"
                      [deferRendering]="false"
                      formControlName="itemCatalogGroupId"
                      #itemCatalogGroupId
                      [readOnly]="!itemCatalogList?.length"
                      (onValueChanged)="
                      selectedItemCatalogGroup(
                          normalStockForm
                            .get('filtersInventory')
                            .get('itemCatalogGroupId').value
                        );getGroupSize()
                        
                      "
                    >
                      <dx-validator>
                        <dxi-validation-rule
                          type="required"
                          message="Catalog Group is required"
                        >
                        </dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box> -->
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="lensSideId" text="Lense Side *"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #lensSideId
                      class="w-100" 
                      formControlName="lensSideId"
                      [valuePrimitive]="true"
                      [data]="lensSideList"
                      [valueField]="'lensSideId'"
                      [textField]="'sideName'" 
                      [readonly]="!lensSideList?.length"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getGroupSize()"
                      [placeholder]="loadingIndicator
                      ? 'Please wait...'
                      : 'Choose Lense Side'"
                      [tabIndex]="16">
                      </kendo-combobox>
                      <kendo-formerror>Lense Side is required</kendo-formerror>
                    </kendo-formfield>
                    <!-- <div>Lense Side<span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      [items]="lensSideList"
                      placeholder="{{
                        loadingIndicator ? 'Please wait...' : 'Choose lense Side'
                      }}"
                      [showClearButton]="true"
                      [deferRendering]="false"
                      displayExpr="sideName"
                      valueExpr="lensSideId"
                      [searchEnabled]="true"
                      formControlName="lensSideId"
                      [readOnly]="!lensSideList?.length"
                      (onValueChanged)="
                      getGroupSize()
                        
                      "
                    >
                      <dx-validator>
                        <dxi-validation-rule
                          type="required"
                          message="Lense Side is required"
                        >
                        </dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box> -->
                  </div>
                </div>
                
                <ng-container *ngIf="normalStockForm.get('filtersInventory').get('isTranspose').value">
                  <div class="col-md-2">
                    <div class="dx-field">
                      <div>SPH:</div>
                      <dx-number-box
                      id="sphTranstose"
                        [inputAttr]="{ autocomplete: 'off' }"
                        placeholder="SPH"
                        formControlName="sphTranstose"
                        [readOnly]="true"
                        [min]="-35" [max]="35"
                         [step]="0.25"
                         [ToFixedDirective]="2"
                         [tabIndex]="17"
                         
                      ></dx-number-box>
                      <dx-tooltip 
                          target="#sphTranstose" 
                          [visible]="normalStockForm.get('filtersInventory').get('sphTranstose').errors && normalStockForm.get('filtersInventory').get('sphTranstose').touched"
                          [hideOnOutsideClick]="false">
                          <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color:rgb(217, 83, 79);">
                              {{normalStockForm.get('filtersInventory').get('sphTranstose').errors?.required ? 'SPH value is required' : ''}}
                              {{normalStockForm.get('filtersInventory').get('sphTranstose').errors?.range ? 'SPH Min: -35 & Max: 30 allowed' : ''}}
                              {{normalStockForm.get('filtersInventory').get('sphTranstose').errors?.stepError ? 'SPH value is not valid' : ''}}
                          </div>
                      </dx-tooltip>
                    </div>
                    <!-- <div class="dx-field">
                      <div>SPH<span>*</span>:</div>
                      <dx-select-box
                        [inputAttr]="{ autocomplete: 'off' }"
                        class="enter-keypress-focus-input"
                        formControlName="sph"
                        [items]="sphList"
                        [readOnly]="sphList?.length == 0"
                        placeholder="Select SPH *"
                        displayExpr="sphValue"
                        valueExpr="sphValue"
                        [showClearButton]="true"
                        [searchEnabled]="true"
                      >
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="SPH is required"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-select-box>
                    </div> -->
                  </div>
                  <div class="col-md-2" *ngIf="selectedItemGroup?.focalId == 1 && selectedItemGroup?.itemTypeMasterId == 2">
                    <!-- <div class="dx-field">
                      <div>CYL<span>*</span>:</div>
                      <dx-select-box
                        [inputAttr]="{ autocomplete: 'off' }"
                        class="enter-keypress-focus-input"
                        formControlName="cyl"
                        [items]="cylList"
                        [readOnly]="cylList?.length == 0"
                        placeholder="Select CYL *"
                        displayExpr="cylValue"
                        valueExpr="cylValue"
                        [showClearButton]="true"
                        [searchEnabled]="true"
                      >
                        <dx-validator>
                          <dxi-validation-rule
                            type="required"
                            message="CYL is required"
                          ></dxi-validation-rule>
                        </dx-validator>
                      </dx-select-box>
                    </div> -->
                    <div class="dx-field">
                      <div>CYL:</div>
                      <dx-number-box
                      id="cylTranstose"
                        [inputAttr]="{ autocomplete: 'off' }"
                        placeholder="CYL"
                        formControlName="cylTranstose"
                        [min]="-15" [max]="15"
                        [readOnly]="true"
                         [step]="0.25"
                         [ToFixedDirective]="2"
                         [tabIndex]="18"
                      ></dx-number-box>
                      <dx-tooltip 
                      target="#cylTranstose" 
                      [visible]="normalStockForm.get('filtersInventory').get('cylTranstose').errors && normalStockForm.get('filtersInventory').get('cylTranstose').touched"
                      [hideOnOutsideClick]="false">
                      <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color:rgb(217, 83, 79);">
                          {{normalStockForm.get('filtersInventory').get('cylTranstose').errors?.required ? 'CYL value is required' : ''}}
                          {{normalStockForm.get('filtersInventory').get('cylTranstose').errors?.range ? 'CYL Min: -15 & Max: 15 allowed' : ''}}
                          {{normalStockForm.get('filtersInventory').get('cylTranstose').errors?.stepError ? 'CYL value is not valid' : ''}}
                      </div>
                  </dx-tooltip>
                    </div>
                  </div>
                </ng-container>
  
                <ng-container *ngIf="!normalStockForm.get('filtersInventory').get('isTranspose').value">
                    <div class="col-md-2">
                      <div class="dx-field">
                        <!-- <my2-selectbox label="DEx (5K, search enabled, *FAST*)" [lookupItems]="sphRangeList"
                         [searchEnabled]="true" [showDataBeforeSearch]="true" ></my2-selectbox> -->
                        <!-- <div>SPH<span>*</span>:</div>
                        <dx-select-box
                          [inputAttr]="{ autocomplete: 'off' }"
                          class="enter-keypress-focus-input"
                          formControlName="sph"
                          [items]="sphRangeList"
                          [readOnly]="sphRangeList?.length == 0"
                          placeholder="Select SPH *"
                          displayExpr="sphValue"
                          valueExpr="sphValue"
                          [showClearButton]="true"
                          [showDataBeforeSearch]="false"
                          [deferRendering]="false"
                          [searchEnabled]="true"
                          (onValueChanged)="getGroupSize()"
                          >
                        </dx-select-box> -->
                        <kendo-formfield>
                          <kendo-label [for]="sphValue" text="SPH *"></kendo-label>
                          <kendo-combobox [virtual]="true"
                          [clearButton]="true" 
                          #sphValue
                          class="w-100" 
                          formControlName="sph"
                          [valuePrimitive]="true"
                          [data]="sphRangeList"
                          [valueField]="'sphValue'"
                          [textField]="'sphValue'" 
                          [readonly]="!sphRangeList?.length"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true" 
                          (valueChange)="getGroupSize();getFnPrice(
                            normalStockForm.get('customerBranchId').value,
                            normalStockForm
                              .get('filtersInventory')
                              .get('itemCatalogGroupId').value,
                            normalStockForm.get('filtersInventory').get('sph').value,
                            normalStockForm.get('filtersInventory').get('cyl').value,
                            normalStockForm.get('filtersInventory').get('addf').value
                            )"
                          [placeholder]="'Choose SPH'"
                          [tabIndex]="17">
                          </kendo-combobox>
                          <kendo-formerror *ngIf="normalStockForm.get('filtersInventory').get('sph').errors?.required">SPH is required</kendo-formerror>
                        </kendo-formfield>
                        
                      </div>
                    </div>
                    <div class="col-md-2" *ngIf="selectedItemGroup?.focalId == 1 && selectedItemGroup?.itemTypeMasterId == 2">
                      <div class="dx-field">
                        <kendo-formfield>
                          <kendo-label [for]="cylValue" text="CYL *"></kendo-label>
                          <kendo-combobox [virtual]="true"
                          [clearButton]="true" 
                          #cylValue
                          class="w-100" 
                          formControlName="cyl"
                          [valuePrimitive]="true"
                          [data]="cylRangeList"
                          [valueField]="'cylValue'"
                          [textField]="'cylValue'" 
                          [readonly]="cylRangeList?.length == 0"
                          [filterable]="true"
                          [kendoDropDownFilter]="{ operator: 'contains' }"
                          [suggest]="true" 
                          (valueChange)="getGroupSize();getFnPrice(
                            normalStockForm.get('customerBranchId').value,
                            normalStockForm
                              .get('filtersInventory')
                              .get('itemCatalogGroupId').value,
                            normalStockForm.get('filtersInventory').get('sph').value,
                            normalStockForm.get('filtersInventory').get('cyl').value,
                            normalStockForm.get('filtersInventory').get('addf').value
                            )"
                          [placeholder]="'Choose CYL'"
                          [tabIndex]="18">
                          </kendo-combobox>
                          <kendo-formerror *ngIf="normalStockForm.get('filtersInventory').get('cyl').errors?.required">CYL is required</kendo-formerror>
                        </kendo-formfield>
                        <!-- <div>CYL<span>*</span>:</div>
                        <dx-select-box
                          [inputAttr]="{ autocomplete: 'off' }"
                          class="enter-keypress-focus-input"
                          formControlName="cyl"
                          [items]="cylRangeList"
                          [readOnly]="cylRangeList?.length == 0"
                          placeholder="Select CYL *"
                          displayExpr="cylValue"
                          valueExpr="cylValue"
                          [deferRendering]="false"
                          [showClearButton]="true"
                          [showDataBeforeSearch]="false"
                          (onValueChanged)="getGroupSize()"
                          [searchEnabled]="true">
                        </dx-select-box> -->
                      </div>
                    </div>
                </ng-container>
              
                <div class="col-md-2"  *ngIf="selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)">
                   <div class="dx-field">
                    <kendo-formfield>
                      <kendo-label [for]="addfValue" text="ADD *"></kendo-label>
                      <kendo-combobox [virtual]="true"
                      [clearButton]="true" 
                      #addfValue
                      class="w-100" 
                      formControlName="addf"
                      [valuePrimitive]="true"
                      [data]="addfRangeList"
                      [valueField]="'addfValue'"
                      [textField]="'addfValue'" 
                      [readonly]="!addfRangeList?.length"
                      [filterable]="true"
                      [kendoDropDownFilter]="{ operator: 'contains' }"
                      [suggest]="true" 
                      (valueChange)="getGroupSize();getFnPrice(
                        normalStockForm.get('customerBranchId').value,
                        normalStockForm
                          .get('filtersInventory')
                          .get('itemCatalogGroupId').value,
                        normalStockForm.get('filtersInventory').get('sph').value,
                        normalStockForm.get('filtersInventory').get('cyl').value,
                        normalStockForm.get('filtersInventory').get('addf').value
                        )"
                      [placeholder]="'Choose ADD'"
                      [tabIndex]="19">
                      </kendo-combobox>
                      <kendo-formerror *ngIf="normalStockForm.get('filtersInventory').get('addf').errors?.required">ADD is required</kendo-formerror>
                    </kendo-formfield>
                    <!-- <div>ADD<span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      class="enter-keypress-focus-input"
                      formControlName="addf"
                      [items]="addfRangeList"
                      [readOnly]="addfRangeList?.length == 0"
                      placeholder="Select ADD *"
                      displayExpr="addfValue"
                      valueExpr="addfValue"
                      [showClearButton]="true"
                      [showDataBeforeSearch]="false"
                      [deferRendering]="false"
                      [searchEnabled]="true"
                      (onValueChanged)="getGroupSize()"
                    >
               
                    </dx-select-box> -->
                  </div> 
                  <!-- <div class="dx-field">
                    <div>ADD <span>*</span>:</div>
                    <dx-number-box
                    id="addf"
                      [inputAttr]="{ autocomplete: 'off' }"
                      placeholder="ADD"
                      formControlName="addf"
                      [min]="0.25" [max]="4"
                       [step]="0.25"
                       [ToFixedDirective]="2"
                       (onValueChanged)="getGroupSize()"
                    ></dx-number-box>
                    <dx-tooltip 
                    target="#addf" 
                    [visible]="normalStockForm.get('filtersInventory').get('addf').errors && normalStockForm.get('filtersInventory').get('addf').touched"
                    [hideOnOutsideClick]="false">
                    <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color:rgb(217, 83, 79);">
                        {{normalStockForm.get('filtersInventory').get('addf').errors?.required ? 'ADD value is required' : ''}}
                        {{normalStockForm.get('filtersInventory').get('addf').errors?.range ? 'ADD Min: 0.25 & Max: 4.00 allowed' : ''}}
                        {{normalStockForm.get('filtersInventory').get('addf').errors?.stepError ? 'ADD value is not valid' : ''}}
                    </div>
                </dx-tooltip>
                  </div> -->
                </div>
                <div class="col-md-2" *ngIf="selectedItemGroup?.focalId == 1">
                    <div class="dx-field">
                      <div>AXIS:</div>
                      
                      <dx-number-box
                      id="axis"
                        [inputAttr]="{ autocomplete: 'off' }"
                        placeholder="AXIS"
                        formControlName="axis"
                        [min]="1"
                         [max]="180"
                         NumberValidate
                         [step]="1"
                         (onValueChanged)="validateZeroValue('axis', normalStockForm.get('filtersInventory').get('axis').value)"
                         SignNotAllowed="43"
                         [tabIndex]="(selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)) ? 20 : 19"
                      >
                      <!-- <dx-validator>
                        <dxi-validation-rule *ngIf="selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3"
                          type="required"
                          message="AXIS is required"
                        ></dxi-validation-rule>
                      </dx-validator> -->
                    </dx-number-box>
                      <dx-tooltip 
                      target="#axis" 
                      [visible]="normalStockForm.get('filtersInventory').get('axis').errors && normalStockForm.get('filtersInventory').get('axis').touched"
                      [hideOnOutsideClick]="false">
                      <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color:rgb(217, 83, 79);">
                          {{normalStockForm.get('filtersInventory').get('axis').errors?.range ? 'AXIS Min: 0 & Max: 180 allowed' : ''}}
                          {{normalStockForm.get('filtersInventory').get('axis').errors?.stepError ? 'AXIS value is not valid' : ''}}
                          <!-- {{normalStockForm.get('filtersInventory').get('axis').errors?.required ? 'AXIS is required' : ''}} -->
                      </div>
                      </dx-tooltip>
                    </div>
                  <!-- <mat-form-field class="w-100">
                      <input id="axis" type="number" matInput formControlName="axis" placeholder="AXIS" step="1" min="0" max="180"
                       autocomplete="off" SignNotAllowed="43">
                  </mat-form-field>
                  <dx-tooltip 
                      target="#axis" 
                      [visible]="normalStockForm.get('filtersInventory').get('axis').errors && normalStockForm.get('filtersInventory').get('axis').touched"
                      [hideOnOutsideClick]="false">
                      <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color:rgb(217, 83, 79);">
                          {{normalStockForm.get('filtersInventory').get('axis').errors?.range ? 'AXIS Min: 0 & Max: 180 allowed' : ''}}
                          {{normalStockForm.get('filtersInventory').get('axis').errors?.stepError ? 'AXIS value is not valid' : ''}}
                      </div>
                  </dx-tooltip> -->
                 </div>
                 <div class="col-md-2">
                  <div class="dx-field">
                    <div>Size <span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      class="enter-keypress-focus-input"
                      formControlName="itemSizeId"
                      [items]="sizeList"
                      [readOnly]="sizeList?.length == 0"
                      placeholder="Select Size *"
                      displayExpr="itemSizeValue"
                      valueExpr="itemSizeId"
                      [showClearButton]="true"
                      [deferRendering]="false"
                      [searchEnabled]="true"
                      
                      [tabIndex]="(selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)) ? 21 : 20"
                     >
                      <dx-validator>
                        <dxi-validation-rule
                        type="required"
                        message="Size is required"
                      ></dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box>
                    <!-- <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      formControlName="itemSizeId"
                      [items]="sizeList"
                      [readOnly]="sizeList?.length == 0"
                      placeholder="Select Size"
                      displayExpr="itemSizeValue"
                      [showClearButton]="true"
                      valueExpr="itemSizeId"
                      (onValueChanged)="getItemCatalog(normalStockForm
                      .get("filtersInventory")
                      .get("itemCatalogGroupId").value,normalStockForm
                      .get("filtersInventory")
                      .get("itemSizeId").value)"
                      >
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="Size is required"
                      ></dxi-validation-rule>
                    </dx-validator>
                    </dx-select-box> -->
                  </div>
                 </div>
                 
                <div class="col-md-2">
                  <div class="dx-field">
                    <div>Unit  <span>*</span>:</div>
                    <dx-select-box
                      [inputAttr]="{ autocomplete: 'off' }"
                      class="enter-keypress-focus-input"
                      formControlName="uomId"
                      [items]="uomsList"
                      [readOnly]="true"
                      placeholder="{{
                        loadingUoms ? 'Please wait...' : 'Unit *'
                      }}"
                      displayExpr="uomname"
                      [deferRendering]="false"
                      valueExpr="uomid"
                      [showClearButton]="true"
                      
                      [searchEnabled]="true"
                      
                    >
                    <!-- [tabIndex]="(selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)) ? 22 : 21" -->
                      <dx-validator>
                        <dxi-validation-rule
                          type="required"
                          message="Unit is required"
                        ></dxi-validation-rule>
                      </dx-validator>
                    </dx-select-box>
                  </div>
                </div>
               
                <div class="col-md-2">
                  <div>Qty <span>*</span>:</div>
                  <!-- [tabIndex]="22" -->
                  <!-- (keyup)="moveToAddItem($event.target.value)" -->
                  <dx-number-box [inputAttr]="{ autocomplete: 'off' }" NumberValidate [min]="1" 
                   (keyup)="validateZeroValue('qty', $event.target.value)"  [max]="1000" placeholder="Qty"
                   
                   formControlName="qty"
                   [tabIndex]="(selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)) ? 22 : 21"
                    >
                      <dx-validator>
                          <dxi-validation-rule type="required" message="Qty is required"></dxi-validation-rule>
                          <!-- <dxi-validation-rule type="range" [min]="1" [max]="9999" message="QTY cannot be less than 1"></dxi-validation-rule> -->
                      </dx-validator>
                  </dx-number-box>
              </div>
              <!-- <div class="col-md-2">
                <div>Price   <span>*</span>:</div>
                  <dx-number-box id="price" [min]="0" format="#0.00"  [inputAttr]="{ autocomplete: 'off' }" [readOnly]="true"
                   placeholder="Price *" formControlName="unitPrice">
                      <dx-validator>
                          <dxi-validation-rule type="required" message="Price is required"></dxi-validation-rule>
                      </dx-validator>
                  </dx-number-box>
                  <dx-tooltip 
                          target="#price" 
                          [visible]="normalStockForm.get('filtersInventory').get('unitPrice').value > 0"
                          [hideOnOutsideClick]="false" position="bottom" >
                          <div *dxTemplate="let data = data of 'content'" style="font-size: 14px;color: #5cb85c">
                              {{priceLabel}}
                          </div>
                      </dx-tooltip>
              </div> -->
              <!-- <div class="col-md-2">
                <div>Amount:</div>
                  <dx-number-box [min]="0" format="#0.00" [readOnly]="true" [value]="totalAmount" [inputAttr]="{ autocomplete: 'off' }"  placeholder="Amount"
                   formControlName="additionAmount">
                  </dx-number-box>
              </div> -->
              <div class="col-2">
                <dx-button 
                    id="submit2"
                    text="Add Item"
                    #addItem
                    type="success"  
                    [tabIndex]="(selectedItemGroup?.itemTypeMasterId == 2 && (selectedItemGroup?.focalId == 2 || selectedItemGroup?.focalId == 3)) ? 23 : 22"
                    [disabled]="(normalStockForm.get('filtersInventory').get('itemCatalogGroupId').value ? null : true || normalStockForm.get('filtersInventory').get('lensSideId').value ? null : true) || (paymentTermValidationData?.isBlock)"
                    class="mt-3"
                    (click)="addToGrid(normalStockForm, 'click')"
                    (onInitialized)="onInitialized($event)"
                    [useSubmitBehavior]="true">
                </dx-button>
            </div>
              </div>
              <div class="row">
                <div class="col-md-12 mt-3">
                  <ng-template [ngIf]="allRequiredErrorShow">
                    <div class="alert alert-danger" role="alert" *ngIf="getFormValidationErrors(normalStockForm)?.length > 0">
                      <div><strong>Oops!</strong></div>
                      <div class="e" *ngFor="let error of getFormValidationErrors(normalStockForm)">{{ error.error | uppercase}} {{error.control | uppercase }}</div>
                    </div>
                  </ng-template>
                </div>
            </div>
            <div class="row mt-3"  #gridScrollElement>
              <div class="col-12" *ngIf="stockLense?.length > 0">
                  <dx-data-grid 
                    [dataSource]="stockLense" 
                    
                    [columnAutoWidth]="true" 
                    [showBorders]="true" 
                    [hoverStateEnabled]="true"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    #stockLensGrid 
                    (onRowUpdated)="onEditorPreparing($event)">
                      <dxo-paging [pageSize]="10"></dxo-paging>
                      <dxo-search-panel [visible]="false"></dxo-search-panel>
                      <dxo-editing mode="cell" [allowUpdating]="true" [allowDeleting]="false" [allowAdding]="false">
                      </dxo-editing>
                      <dxi-column dataField="itemCatalogGroupId" caption="Group #" cssClass="text-center" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="itemName" caption="Item Name" cssClass="text-left" [allowEditing]="false"></dxi-column>
                      <!-- <dxi-column dataField="sideName" caption="Side" cssClass="text-center" [width]="70" [allowEditing]="false"></dxi-column> -->
                      <dxi-column dataField="lensSideId" [visible]="true" cssClass="text-center"
                        [allowHeaderFiltering]="false" [allowFiltering]="false" caption="Side">
                        <dxo-lookup [dataSource]="lensSideListForGrid" displayExpr="sideName" valueExpr="lensSideId">
                        </dxo-lookup>
                      </dxi-column>
                      
                      
                      <dxi-column dataField="sph" caption="SPH" cssClass="text-center" [width]="70" [allowEditing]="false" cellTemplate="sphTemplate"></dxi-column>
                      <dxi-column dataField="cyl" caption="CYL"  cssClass="text-center"  [width]="70" [allowEditing]="false" cellTemplate="cylTemplate"></dxi-column>
                      <dxi-column dataField="axis" caption="AXIS" cssClass="text-center" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="addf" caption="Add"   cssClass="text-center" [width]="70" [allowEditing]="false" cellTemplate="addTemplate"></dxi-column>
                      
                      
                      <dxi-column dataField="size" caption="Size" cssClass="text-center" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="uomname" caption="Unit" cssClass="text-center" [allowEditing]="false"></dxi-column>
                      <dxi-column dataField="qty" caption="QTY" cssClass="text-center" [allowEditing]="normalStockForm.get('ponumber').value ? false : true">
                        <dxi-validation-rule *ngIf="!salesOrderId"  type="custom" [validationCallback]="validateQty.bind(this)"
                          message='Qty must be greater than 0 price'></dxi-validation-rule>
                          <dxi-validation-rule *ngIf="salesOrderId"  type="custom" [validationCallback]="validateQty.bind(this)"
                          message='Qty must be greater than IssuedQTY'></dxi-validation-rule>
                      </dxi-column>
                      
                      <dxi-column dataField="stockIssueQuantity" caption="I.Qty" [visible]="salesOrderId > 0" cssClass="text-center" [allowEditing]="false"></dxi-column>
                      <!-- <dxi-column dataField="unitPrice" caption="Price" cssClass="text-center" [allowEditing]="false"></dxi-column> -->
                      <!-- <dxi-column dataField="total" caption="Total" cssClass="text-center" [allowEditing]="false"></dxi-column> -->
                      <dxi-column caption="Actions" cssClass="text-center" cellTemplate="actionTemplate" [allowFiltering]="false" [allowEditing]="false"></dxi-column>
                      <div class="employee dx-row" *dxTemplate="let d of 'sphTemplate'" >
                          <div class="main-row">
                              <div class="text-center">
                                  <div *ngIf="d.data.sph != null">
                                      <mat-chip class="mr-1">{{d.data.sph }}</mat-chip>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="employee dx-row" *dxTemplate="let d of 'cylTemplate'" >
                          <div class="main-row">
                              <div class="text-center">
                                  <div *ngIf="d.data.cyl != null">
                                      <mat-chip class="mr-1">{{d.data.cyl }}</mat-chip> 
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="employee dx-row" *dxTemplate="let d of 'addTemplate'" >
                          <div class="main-row">
                              <div class="text-center">
                                  <div *ngIf="d.data.addf != null">
                                      <mat-chip class="mr-1">{{d.data.addf}}</mat-chip> 
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div *dxTemplate="let d of 'actionTemplate'">
                          <button type="button" mat-icon-button matTooltip="Delete Item" [swal]="deleteSwal">
                              <mat-icon color="warn">delete</mat-icon>
                          </button>
                          <swal #deleteSwal title="Are you sure want to delete ?" text="This cannot be undone" type="question"
                              [showCancelButton]="true" [focusCancel]="true"
                              (confirm)="removeStockLensItem(d.data.index)">
                              <!-- (confirm)="removeStockLensItem(d.data.itemCatalogGroupId)" -->
                          </swal>
                      </div>
                      <dxo-summary [recalculateWhileEditing]="true">
                          <dxi-total-item
                              column="uomname"
                              [customizeText]="customizeUnit"
                              alignment="center"
                              summaryType="sum">
                          </dxi-total-item>
                          <dxi-total-item
                              column="qty"
                              [customizeText]="customizeText"
                              alignment="center"
                              summaryType="sum">
                          </dxi-total-item>
                          <dxi-total-item
                              column="stockIssueQuantity"
                              [customizeText]="customizeText"
                              alignment="center"
                              summaryType="sum">
                          </dxi-total-item>
                          <!-- <dxi-total-item
                          column="unitPrice"
                          [customizeText]="customizeText"
                          alignment="center"
                          summaryType="sum">
                      </dxi-total-item>
                          <dxi-total-item
                              column="total"
                              summaryType="sum"
                              alignment="center"
                              [customizeText]="customizeText">
                          </dxi-total-item> -->
                      </dxo-summary>
                  </dx-data-grid>
              </div>
          </div>
            </div>
            <div class="footer" *ngIf="stockLense?.length > 0">
              <div class="row">
                  <div class="col text-right">
                    <!-- <dx-speed-dial-action
                      icon="reset"
                      label="Reset"
                      [index]="2"
                      >
                    </dx-speed-dial-action> -->
                    <ng-container *ngIf="!holdSalesOrder && !hideSubmitBtn && !(isApiInProgress$ | async)">
                      <dx-speed-dial-action  *ngIf="!loadingIndicator"
                      icon="add"
                      label="{{salesOrderId ? 'Update' : 'Save'}}"
                      [index]="1"
                      (onClick)="saveSalesOrderLens()"
                      [disabled]="loadingIndicator">
                    </dx-speed-dial-action>
                    </ng-container>
                         
                  </div>
              </div>  
          </div>
          </app-panel>
        </ng-container>
      </form>
      <swal #saveSwal></swal>
    </div>
  </div>
</div>
